import { useTranslation } from "react-i18next";
import type { SmartReport } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import OrganizationSelect from "components/select/OrganizationSelect/OrganizationSelect";
import ImageFromStrapiMedia from "common/components/ImageFromStrapiMedia/ImageFromStrapiMedia";
import SmartReportForm from "./SmartReportForm";

function SidebarSmartReportForm({ ...props }: any) {
  return (
    <CrudEdit
      collectionName="smart-reports"
      Form={SmartReportForm}
      {...props}
    />
  );
}

function SmartReports() {
  const { t } = useTranslation();

  const columns: TableColumn<SmartReport>[] = useMemo(
    () => [
      {
        field: "organization",
        header: t("smart-reports.organization"),
        customRender: (rowData: SmartReport) => (
          <div className="flex items-center gap-4">
            {rowData.organization?.logo && (
              <div className="w-20 h-16 overflow-hidden">
                <img
                  src={ImageFromStrapiMedia(rowData.organization.logo).uri}
                  alt={rowData.organization.name}
                  className="object-cover rounded-lg"
                />
              </div>
            )}
            <span className="font-bold">{rowData.organization?.name}</span>
          </div>
        ),
      },
      {
        field: "media",
        header: t("smart-reports.media"),
        renderType: "file",
      },
    ],
    [t]
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ];
  }, [t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "organization$eq",
        label: t("smart-reports.organization"),
        renderType: "custom",
        renderComponent: (
          <OrganizationSelect
            isClearable
            placeholder={t("smart-reports.organization")}
          />
        ),
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="smart-reports"
      columns={columns}
      headerActions={actions}
      filters={filters}
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarSmartReportForm}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default SmartReports;
